import { setHeader } from '../widget/helpers/axios';

export const setConversationToken = ( token ) => {
    localStorage.setItem('cw_conversation', token);
    setHeader('X-Auth-Token', token);
}